import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import withMemo from '../../decorators/withMemo'
import AboutTemplate from '../../templates/About'
import { useHeader, useFooter } from '../../hooks/useAppLayout'
import { useNavPath } from '../../hooks/useNavPath'
import { Router } from '../../routes'
import routes from '../../routes/definitions'
import { selectors as AuthSelectors } from '../../redux/auth/redux'

import sagas from './sagas'


const About = () => {
  const { t } = useTranslation()
  const headerProps = useHeader()
  const footerProps = useFooter()
  const navPathProps = useNavPath()
  const isConnected = useSelector(AuthSelectors.isConnected)

  const layoutProps = {
    theme: {
      maxWidth: 640,
    },
  }
  const pageTitleProps = {
    text: t('about'),
  }

  const paragraphProps = {
    text: t('about_page_introduction'),
  }

  const pageActionsProps = {
    actions: [
      {
        link: isConnected ? Router.getRouteUrl(routes.start) : Router.getRouteUrl(routes.scholarship),
        label: t('apply'),
      },
    ],
  }

  const aboutTemplateProps = {
    headerProps,
    navPathProps,
    footerProps,
    layoutProps,
    pageTitleProps,
    paragraphProps,
    pageActionsProps,
  }


  return (<AboutTemplate {...aboutTemplateProps} />)
}

About.getInitialProps = async(ctx) => ctx.store.saga.run(sagas.init, ctx).toPromise()

About.propTypes = {}

About.defaultProps = {}

export default withMemo()(About)
